import { AppBar, Box, Button, Container, Toolbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { showError, showSuccess } from '../../actions/misc/misc.actions'
import { MainTitle } from '../../components'
import AdvancedSettings from '../../components/Cards/Market/AdvancedSettings'
import BasicSettings from '../../components/Cards/Market/BasicSettings'
import { api } from '../../services/api'

const useStyles = makeStyles((theme) => ({
	container: {
		padding: 24
	},
	card: {
		width: 350,
		marginRight: 24
	},
	header: {
		textDecoration: 'none'
	},

	fullWidthcard: {
		border: '1px solid #E5E5E5',
		boxShadow: 'none',
		width: '100%',
		marginBottom: 8
	},
	// header: {
	// 	padding: '8px 24px',
	// 	'& .MuiCardHeader-action': {
	// 		margin: 0
	// 	},
	// 	'& .MuiCardHeader-title': {
	// 		textTransform: 'none'
	// 	}
	// },
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},

	arrow: {
		marginTop: 6
	},
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
		// marginRight: theme.spacing(2)
	},
	doubleSizeInput: {
		width: '66%'
	},
	fullWidth: {
		width: '100%'
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px'
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 4
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important',
		zIndex: 1300
	},
	selectAdornment: {
		marginRight: theme.spacing(3)
	}
}))

const services = ['Daycare & Boarding', 'Bar & Park', 'Home Services']

const Markets = () => {
	const params = useParams()
	const dispatch = useDispatch()

	const markets = useSelector((state) => state.specific.markets.markets)
	const selectedMarketState = useSelector((state) => state.specific.markets.selectedMarket)

	const [selectedMarket, setSelectedMarket] = useState(null)

	const [isSaveShown, setIsSaveShown] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	const classes = useStyles()

	useEffect(() => {
		if (params.marketId && markets && markets.length && !selectedMarket) {
			const mkt = markets.find((m) => m._id === params.marketId)
			if (mkt) {
				dispatch({ type: 'SET_MARKET', payload: mkt })
				setSelectedMarket(mkt)
			}
		}
	}, [params])

	const updateMarket = (key, val) => {
		setSelectedMarket({ ...selectedMarket, [key]: val })
		setIsSaveShown(true)
	}

	const editMarketOnBd = async () => {
		try {
			setIsLoading(true)
			console.log('selected...', selectedMarket)
			// console.log('trial_settings...', selectedMarket?.available_membership_types[6]?.trial_settings)
			// we are sending the available memberships as objects to be updated as well
			const market = await api.put(`/market/${selectedMarket._id}`, selectedMarket)
			// update state
			dispatch({ type: 'SET_MARKET', payload: market.data })
			dispatch(showSuccess('Market updated'))
			setIsSaveShown(false)
		} catch (error) {
			dispatch(showError(error))
		} finally {
			setIsLoading(false)
		}
	}

	const clearChanges = () => {
		setSelectedMarket({ ...selectedMarketState })
		setIsSaveShown(false)
	}

	const updateMembership = (id, key, val) => {
		let types = selectedMarket.available_membership_types.map((t) => {
			if (t._id === id) {
				return {
					...t,
					[key]: val
				}
			}
			return t
		})

		setSelectedMarket({
			...selectedMarket,
			available_membership_types: types
		})
		setIsSaveShown(true)
	}

	const updateTrialMembership = (id, key, val) => {
		let types = selectedMarket.available_membership_types.map((t) => {
			if (t._id === id) {
				return {
					...t,
					trial_settings: {
						...t.trial_settings,
						[key]: val
					}
				}
			}
			return t
		})

		setSelectedMarket({
			...selectedMarket,
			available_membership_types: types
		})
		setIsSaveShown(true)
	}

	return (
		<Box className={classes.container}>
			<Box>
				<MainTitle title={`${selectedMarket?.city}, ${selectedMarket?.state} - Market Settings`} />
				<BasicSettings selectedMarket={selectedMarket} updateMarket={updateMarket} />
				<AdvancedSettings
					selectedMarket={selectedMarket}
					updateMarket={updateMarket}
					updateMembership={updateMembership}
					updateTrialMembership={updateTrialMembership}
				/>
			</Box>
			{isSaveShown ? (
				<AppBar position="fixed" color="primary" className={classes.appBar}>
					<Toolbar>
						<Container maxWidth="md">
							<Button
								variant="contained"
								color="secondary"
								disabled={isLoading}
								style={{ marginRight: '8px' }}
								onClick={() => editMarketOnBd()}>
								Save Changes
							</Button>
							<Button variant="outlined" color="secondary" onClick={clearChanges}>
								Cancel
							</Button>
						</Container>
					</Toolbar>
				</AppBar>
			) : null}
		</Box>
	)
}

export default Markets
